module.exports = __webpack_public_path__ + "img/art6.7f1c079e.png";